
import React, {useState, useEffect, useRef} from 'react';
import toastr from 'toastr';
import _ from 'lodash';
import Loading from '../Loading';
import Modal from 'react-modal';
import {
  Box,
  Typography,
  Autocomplete,
  TextField,
  IconButton,
  Menu,
  MenuItem,
  Paper
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ClearIcon from '@mui/icons-material/Clear';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import {
  placeAutocomplete,
  placeDetail,
  getLocationName,
  getDistanceMoney,
} from '../../clientServices/order'
import {
  getMyRegion,
  getDefaultOriginPlace,
  // getRecentlyOrigin,
  // getRecentlyDestination
} from '../../ultil'
import {
  listDefaultLocation,
} from '../../clientServices/member'

const MTAMap = React.lazy(() =>
  import("../MTAMap")
)

const ITEM_HEIGHT = 48;
let delay = setTimeout(function () {

}, 300);

const RenderOption = (props, option, state) => {
  return (
    <li {...props} style={{fontSize: '1.4rem'}}>
      <Box onClick={(e)=>props.onClick(e)} display={"flex"} flexDirection={"row"} alignItems={"center"}>
        {option.placeType === 'sub' ? <img width="20px" src="/image/empty.png"/> : <LocationOnIcon />}
        <Box display={"flex"} ml={3} flexDirection={"column"}>
          <Typography sx={{fontSize: '1.4rem'}} className="card-line-1" color={"text.primary"}>{option.placeType === 'sub' ? <>&#8226;</> : null} {option.nameDefault || _.get(option, 'structured_formatting.main_text')}</Typography>
          {option.placeType === 'sub' ? null : <Typography sx={{fontSize: '1.2rem'}} className="card-line-1" color={"text.secondary"}>{_.get(option, 'structured_formatting.secondary_text') || option.label}</Typography>}
        </Box>
      </Box>
    </li>
  );
};

const RenderGroup = ({key, group, children}) => {
  return <Box key={key}>
    <Typography sx={{padding: '5px 15px'}}>{group}</Typography>
    {children}
    </Box>
};

const CustomPaper = (props) => {
  return <Paper elevation={8} {...props} />;
};

export default function PlaceAutoCompleteInput({
  autoFocus,
  currentLocation = true,
  className="input-lg hover-blue border-none",
  classOptionsBtn = "btn btn-lg dropdown-toggle border-none button-white padding-none",
  placeholder,
  region,
  onChangePlace,
  defaultInput = '',
  pointSelectionStatus,
  type,
  setIsOpen,
  isCheckLocation = false,
  isCheckChooseMap = false,
  isCheckAddressManagement = false,
  recentlyType
}) {
  const [listAutocomplete, setListAutocomplete] = useState([])
  const [value, setValue] = useState('');
  const [inputValue, setInputValue] = useState('');

  const [showList, setShowList] = useState(false)
  const [showListDefault , setShowListDefault] = useState(false)
  const [focus, setFocus] = useState(false)
  const [places, setPlaces] = useState([])
  const [loading, setLoading] = useState(false)
  const [onOffModal , setOnOffModal] = useState(false)
  const [markers, setMarkers] = useState([]);
  const [center, setCenter] = useState({ });
  const [nameAddress , setNameAddress] = useState("")
  const [loadCurrentPosition, setLoadCurrentPosition] = useState(false)
  const [checkButton , setCheckButton] = useState(false)
  const [savedAddressList , setSavedAddressList] = useState([])
  const [isCheck, setIsCheck] = useState(true)
  useEffect(()=>{
    getListDefaultLocation()
  },[])

  const getListDefaultLocation = () => {
    listDefaultLocation({})
    .then(res=>{
      const defaultPlaces = res.data.map(item=>{
        item.groupBy = 'Địa chỉ đã lưu'
        return item
      })
      setAutocompleteList(defaultPlaces)//.concat(getListRecentPlaces())
    })
  }

  const getListRecentPlaces = () => {
    let recentlArray = []
    let groupBy = ''
    switch (recentlyType) {
      case 'origin':
        recentlArray = recentlArray.concat(getRecentlyOrigin(), getRecentlyDestination())
      break;
      case 'destination':
        recentlArray = recentlArray.concat(getRecentlyDestination(), getRecentlyOrigin())
      break;
      default:
    }
    return recentlArray;
  }

  const getPlaceAutoComplete = (input) => {
    placeAutocomplete({
      input,
      region: getMyRegion()
    }).then((res)=>{
      const newList = []
      res.predictions.forEach(item=>{
        newList.push(item)
        const subAddress = _.get(item, 'subAddress',[])
        if(!_.isEmpty(subAddress)) {
          subAddress.forEach((sub, i) => {
            sub.structured_formatting = {
              main_text: sub.description,
              secondary_text: item.description
            }
            sub.description = `${sub.description} - ${item.description}`
            sub.placeType = 'sub'
            newList.push(sub)
          });
        }
      })
      setAutocompleteList(newList)
    })
  }

  const setAutocompleteList = (array = []) => {
    setListAutocomplete(array.map(item=>{
      item.label = item.name || item.description
      return item
    }))
  }

  const onClickAutocompeleItem = (item = {}) => {
    if (item && item.place_id) {
      onClickPlace(item, 0)
    } else if (item && item.name) {
      btnClickAddressList(item, 0)
    }
  }

  const openModelPlaceHistory = () => {
    setIsOpen(true)
  }
  const moveCursorToEnd = (end) => {
    let len = end.value.length;

    // Mostly for Web Browsers
    if (end.setSelectionRange) {
        end.focus();
        end.setSelectionRange(len, len);
    } else if (end.createTextRange) {
        var t = end.createTextRange();
        t.collapse(true);
        t.moveEnd('character', len);
        t.moveStart('character', len);
        t.select();
    }
  }
  useEffect(()=>{
    setInputValue(defaultInput)
  }, [defaultInput])

  const getPlaceAutoCompletes = (value) => {
    clearTimeout(delay)
    if (value.length > 3) {
      delay = setTimeout(function () {
        if (focus) {
          setShowList(true)
        }
        getPlaceAutoComplete(value)
      }, 1000);
    } else if (!value) {
      getListDefaultLocation()
    }
  }
  const onFocusAutoText = (e) => {
    setTimeout(function () {
      e.target.scrollIntoView({behavior: "smooth", block: "center"})
    }, 500);
    // getPlaceAutoCompletes(inputValue)
  }

  // chuyền Id vào đây luôn
  const onClickPlace = (place, i, data ) => {
    if(i == 0){
      placeDetail({
        placeid: place.place_id
      })
        .then(res=>{
          setInputValue(place.description)
          setShowList(false)
          onChangePlace({
            address: place.description,
            structured_formatting: place.structured_formatting,
            geometry: {
              lat: _.get(res, 'result.geometry.location.lat', null),
              long: _.get(res, 'result.geometry.location.lng', null),
            }
          })
        }).catch(e=>{

        })
    }else if(i == 1){
      for (let index = 0; index < places.length; index++) {
        if(index == data && place.hideAll == 0 && place.place_id == places[index].place_id){
          places[index].hideAll = 1
        }else if(place.hideAll == 1 && place.place_id == places[index].place_id){
          places[index].hideAll = 0
        }
      }
      setPlaces(_.cloneDeep(places))
    }
  }
  const onClickPlaceSubAddress = (place, dataSubAddress) =>{
    placeDetail({
      placeid: dataSubAddress.place_id,
      subId: dataSubAddress._id,
      description: dataSubAddress.description,
    })
    .then(res=>{
      let data = res.result
      setInputValue(data.subAddress.name+"-"+data.formatted_address)
      setShowList(false)
      onChangePlace({
        address: data.subAddress.name+"-"+data.formatted_address,
        geometry: {
          lat: data.subAddress.location ? data.subAddress.location.lat : data.geometry.location.lat ,
          long: data.subAddress.location ? data.subAddress.location.lng : data.geometry.location.lng ,
        }
      })
    }).catch(e=>{

    })
  }
  const selectPointOnMap = () => {
    if (getDefaultOriginPlace()) {
      chooseLatlng(getDefaultOriginPlace())
    }else{
      btnCurrentPosition()
    }
  }



  const getPermistion = () => {
    return new Promise(function(resolve, reject) {
      if (navigator && navigator.permissions) {
        navigator.permissions.query({name:'geolocation'})
          .then(function(result) {
            switch (result.state) {
              case 'granted':
              case 'prompt':
              resolve(true)
              break;
              default:
              resolve(true)
            }
          });
      } else {
        resolve(true)
      }
    });

  }

  const getLocation = async (cb) => {
    const permissions = await getPermistion()
    if(navigator.geolocation) {
      setLoading(true)
      navigator.geolocation.getCurrentPosition((position)=>{
        getLocationName({
          lat: position.coords.latitude,
          lng: position.coords.longitude
        }).then(res=>{
          cb(null, {
            address: _.get(res, 'data', ''),
            geometry:{
              lat: position.coords.latitude,
              long: position.coords.longitude
            }
          })
        })
          .catch(err=>{
            cb(true)
          })
      },(error)=>{
        cb(true)
      });
    } else {
      cb(true)
    }

  }

  const chooseMyLocation = () => {
    getLocation((err, place)=>{
      setLoading(false)
      if (place) {
        setInputValue(place.description || place.address)
        setShowList(false)
        onChangePlace(place)
      } else {
        toastr.error('Không thể truy cập vị trí của bạn!')
      }
    })
  }

  const btnClose = () => {
    setCheckButton(false)
    setOnOffModal(false)
  }
  const btnSubmitLocation = () => {
    placeAutocomplete({
      input:nameAddress,
      region: getMyRegion()
    }).then((res)=>{
      setCheckButton(false)
      onClickPlace(res.predictions[0], 0)
      setOnOffModal(false)
    }).catch((e)=>console.log(e))
  }

  const btnCurrentPosition = () => {
    setLoadCurrentPosition(true)
    getLocation((err, place)=>{
      setLoadCurrentPosition(false)
      setLoading(false)
      if (place) {
        chooseLatlng(place)
      } else {
        listDefaultLocation({})
        .then(res=>{
          if(res.data && res.data.length !=0 ){
            var data = {
              address:res.data[0].name,
              geometry:{
                lat: res.data[0].location.lat,
                long: res.data[0].location.lng
              }
            }
            chooseLatlng(data)
          }else{
            toastr.error('Không thể truy cập vị trí của bạn!')
          }
        })
      }
    })
  }

  const onChooseMap = (location) =>{
    if(loadCurrentPosition == false){
      setCheckButton(true)
      setMarkers([{
        icon: "/icon/pin/pin-empty-red.png",
        anchor: [20, 53],
        scaledSize: [40, 53],
        lat: location.latlng.lat,
        lng: location.latlng.lng,
      }])
      getLocationName({
          lat:location.latlng.lat,
          lng:location.latlng.lng,
      }).then(res=>{
          setNameAddress(res.data)
      })
    }
  }
  const chooseLatlng = (place) => {
    setOnOffModal(true)
    setMarkers([{
      icon: "/icon/pin/pin-empty-red.png",
      anchor: [20, 53],
      scaledSize: [40, 53],
      lat: place.geometry.lat,
      lng: place.geometry.long,
    }])
    setCenter({
      lat: place.geometry.lat,
      lng: place.geometry.long,
    })
    getLocationName({
      lat: place.geometry.lat,
      lng: place.geometry.long,
  }).then(res=>{
      setNameAddress(res.data)
  })

  }
  const btnClickAddressList = (place, i) => {
    placeAutocomplete({
      input:place.name,
      region: getMyRegion()
    }).then((res)=>{
      onClickPlace(res.predictions[0], i)
    }).catch((e)=>console.log(e))
  }
  const btnSeeMore = (place , data) => {
    setIsCheck(false)
    for (let index = 0; index < places.length; index++) {
      if(index == data && place.seeMore == 0 && place.place_id == places[index].place_id){
        places[index].seeMore = 1
      }else if(place.hideAll == 1 && place.place_id == places[index].place_id){
        places[index].seeMore = 0
      }
    }
    setPlaces(_.cloneDeep(places))

  }

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClickMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  return (
    <>
    <Loading open={loading}/>
    <Autocomplete
      disableClearable
      blurOnSelect
      value={value}
      renderOption={RenderOption}
      renderGroup={RenderGroup}
      onChange={(event, newValue) => {
        onClickAutocompeleItem(newValue)
        setValue(newValue);
      }}
      inputValue={inputValue}
      onInputChange={(event, newInputValue) => {
        getPlaceAutoCompletes(newInputValue)
        setInputValue(newInputValue);
      }}
      freeSolo
      filterOptions={x => x}
      groupBy={(opt) => opt.groupBy}
      options={listAutocomplete}
      PaperComponent={CustomPaper}
      renderInput={(params) => <TextField
          autoComplete="off"
          {...params}
          onFocus={onFocusAutoText}
          label={placeholder}
          autoFocus={autoFocus}
          InputLabelProps={{
            ...params.InputLabelProps,
            sx: {
              fontSize: '1.4rem'
            }
          }}
          InputProps={{
            ...params.InputProps,
            sx: {
              fontSize: '1.4rem'
            },
            endAdornment: (
            <>
            {
              isCheckLocation || isCheckChooseMap || isCheckAddressManagement ?
              <>
                {
                  inputValue ?
                  <IconButton
                    onClick={(e)=>{
                      // e.stopPropagation()
                      getPlaceAutoCompletes('')
                      setInputValue('')
                    }}
                  >
                    <ClearIcon />
                  </IconButton>
                  :null
                }
                <IconButton
                  aria-controls={open ? 'long-menu' : undefined}
                  aria-expanded={open ? 'true' : undefined}
                  aria-haspopup="true"
                  onClick={handleClickMenu}
                >
                  <MoreVertIcon />
                </IconButton>
                <Menu
                  MenuListProps={{
                    'aria-labelledby': 'long-button',
                  }}
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleCloseMenu}
                  PaperProps={{
                    style: {
                      maxHeight: ITEM_HEIGHT * 4.5
                    },
                  }}
                >
                {
                  isCheckLocation && (
                    <MenuItem onClick={()=>{
                      chooseMyLocation()
                      handleCloseMenu()
                    }}>
                      Sử dụng vị trí hiện tại
                    </MenuItem>
                  )
                }
                {
                  isCheckChooseMap && (
                    <MenuItem onClick={()=>{
                      selectPointOnMap()
                      handleCloseMenu()
                    }}>
                      Chọn điểm trên bản đồ
                    </MenuItem>
                  )
                }
                {
                  isCheckAddressManagement && (
                    <MenuItem onClick={()=>{
                      openModelPlaceHistory()
                      handleCloseMenu()
                    }}>
                      Quản lý địa chỉ
                    </MenuItem>
                  )
                }
                </Menu>
              </>
              :null
            }
            </>
            )
          }}
        />}
    />

    <Modal
     ariaHideApp={false}
     isOpen={onOffModal}
       style={{
         content : {
             borderRadius: '2px',
             display: 'block',
             overflow: 'hidden',
             inset:"0px",
             padding:"0px",
           },
         overlay : {
           alignItems: 'flex-start',
           display: 'flex',
           height: '100%',
           justifyContent: 'center',
           left: 0,
           overflowY: 'auto',
           position: 'fixed',
           top: 0,
           width: '100%',
           zIndex: 2050,
           backgroundColor   : 'rgba(0,0,0,.4)',
         }
       }}

     >
     <div className="animated fadeInDown" style={{width: '100%', height: '100%', backgroundColor: '#87C0D7', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
       {
         loadCurrentPosition == false ?
         <div className="leaflet-top " style={{maxWidth:'600px',background:'#fff',width:'100%',height:"auto",boxShadow: "0px 0px 6px 5px #9E9E9E"}}>
           {
             nameAddress ?
             <div>
               <h3 className="text-center"  style={{marginTop:"30px",color:"black"}}>
                 Vị trí
                 <br/>
                 <br/>
                 {nameAddress}
               </h3>
               <div className="arg-row  text-center leaflet-control" style={{float:'none',padding:'15px'}}>
                 {
                   checkButton == true ?
                   <div className="arg-col ">
                     <button type="button" onClick={() => btnCurrentPosition()} className="btn btn-w-m btn-warning ">Vị trí hiện tại</button>
                   </div>
                   : null
                 }
                 <div className="arg-col ">
                   <button type="button" onClick={() => btnSubmitLocation()} className="btn btn-w-m btn-primary ">Xác nhận</button>
                 </div>
                 {/* Các nút sát nhau xấu */}
                 <div className="arg-col" style={{paddingTop: checkButton == true ? "6px" : null}} >
                   <a type="button" onClick={() => btnClose()} className="btn btn-w-m btn-default" style={{color:'black'}}>Đóng</a>
                 </div>
               </div>
             </div>
             :
             <div>
               <h3 className="text-center " style={{marginTop:"30px",color:"black"}}>
               Click chuột trên bản đồ để chọn điểm
               </h3>
               <div className="arg-row  text-center leaflet-control" style={{float:'none',padding:'15px'}}>
                 <div className="arg-col ">
                   <button type="button" onClick={() => btnCurrentPosition()} className="btn btn-w-m btn-warning ">Vị trí hiện tại</button>
                 </div>
                 <div className="arg-col">
                   <a type="button" onClick={() => btnClose()} className="btn btn-w-m btn-default" style={{color:'black'}}>Đóng</a>
                 </div>
               </div>
             </div>
           }
         </div>
         :
         <div className="leaflet-top " style={{background:'#fff',width:'30%',height:"auto",boxShadow: "0px 0px 6px 5px #9E9E9E"}}>
             <div>
               <h3 className="text-center"  style={{marginTop:"30px",color:"black"}}>
                 Hệ thống đang lấy vị trí hiện tại của bạn
               </h3>
               <h1 className="text-center">
                 <i className="fa fa-spinner fa-pulse  fa-fw"></i>
               </h1>
             </div>
         </div>
       }

       {
         center ? (
           <React.Suspense fallback={<div />}   >

             <MTAMap
               onClick={onChooseMap}
               center={center}
               markers={markers}
               nameAddress={nameAddress}
             />
           </React.Suspense>
         )
         :
         <>
         <img className="" src="/images/loadingfail.png" height="50%" width="auto"/>
         <h3>Chọn điểm lấy hàng để tải bản đồ</h3>
         </>
       }
       </div>
     </Modal>

    </>
  );
}
